import { TimeoutError as KyTimeoutError } from 'ky';

// Note: Just wrapping Ky errors so they're more easily accessible from outside the http package + for future extensibility
export class TimeoutError extends KyTimeoutError {
    public fullErrorMessage: string;

    constructor(request: Request) {
        super(request);

        this.fullErrorMessage = this.message;
        this.message = 'Timeout Error';
    }
}
